/**
 * 项目详情及各 Tab 模块共享的工具函数
 */

/** 不进行四舍五入，按指定位数直接截断 */
export function truncateNumber(val: number, decimals = 1): string {
  if (isNaN(val)) return '0';
  const factor = Math.pow(10, decimals);
  const truncated = Math.trunc(val * factor) / factor;
  return truncated.toFixed(decimals);
}

export function formatMoney(amount?: number | string, currency = 'CNY', noShort = false) {
  if (amount === undefined || amount === null || amount === '') return '-';
  const val = Number(amount);
  if (isNaN(val)) return '-';
  const symbol = currency === 'USD' ? '$' : '¥';
  if (!noShort && val >= 10000) {
    return `${symbol} ${truncateNumber(val / 10000, 1)} 万`;
  }
  return `${symbol} ${val.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 6 })}`;
}

export function formatDate(dateStr?: string) {
  if (!dateStr) return '-';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr.substring(0, 10);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function formatNumber(num?: number | string) {
  if (num === undefined || num === null || num === '') return '-';
  const val = Number(num);
  if (isNaN(val)) return '-';
  if (val >= 100000000) {
    return `${truncateNumber(val / 100000000, 1)} 亿`;
  }
  if (val >= 10000) {
    return `${truncateNumber(val / 10000, 1)} 万`;
  }
  return val.toLocaleString();
}

export function getStatusConfig(status?: string) {
  const s = (status || '').toUpperCase();

  // 最新 11 种项目状态
  if (s === 'PENDING_CHANNEL_CONFIGURATION') {
    return { label: '待配置渠道', color: 'bg-amber-100 text-amber-800' };
  }
  if (s === 'PENDING_CONTRACT_SIGNING') {
    return { label: '待签署合同', color: 'bg-amber-100 text-amber-800' };
  }
  if (s === 'PENDING_PLATFORM_SIGNATURE') {
    return { label: '待平台盖章', color: 'bg-amber-100 text-amber-800' };
  }
  if (s === 'CONTRACT_RESIGN_REQUIRED') {
    return { label: '需重签合同', color: 'bg-red-100 text-red-700' };
  }
  if (s === 'CONTRACT_ARCHIVING') {
    return { label: '合同归档中', color: 'bg-blue-100 text-blue-700' };
  }
  if (s === 'PREPARING_RELEASE') {
    return { label: '发行准备中', color: 'bg-sky-100 text-sky-700' };
  }
  if (s === 'PUBLISHING') {
    return { label: '发行发布中', color: 'bg-indigo-100 text-indigo-700' };
  }
  if (s === 'OPERATING') {
    return { label: '运营中', color: 'bg-emerald-100 text-emerald-700' };
  }
  if (s === 'PAUSED') {
    return { label: '已暂停', color: 'bg-gray-100 text-gray-700' };
  }
  if (s === 'OFFLINE') {
    return { label: '已下架', color: 'bg-gray-200 text-gray-600' };
  }
  if (s === 'TERMINATED') {
    return { label: '已终止', color: 'bg-red-50 text-red-600' };
  }

  // 兼容老数据与渠道状态/兜底
  if (s === 'ONLINE') {
    return { label: '已上线', color: 'bg-emerald-100 text-emerald-700' };
  }
  if (s === 'ACTIVE' || s === 'RUNNING' || s === 'PUBLISHED') {
    return { label: '已确认', color: 'bg-emerald-100 text-emerald-700' };
  }
  if (s === 'PENDING' || s === 'PENDING_REVIEW' || s === 'IN_AUDIT') {
    return { label: '审核中', color: 'bg-amber-100 text-amber-800' };
  }
  if (s === 'COMPLETED' || s === 'FINISHED') {
    return { label: '已完成', color: 'bg-blue-100 text-blue-700' };
  }
  if (s === 'DISPUTED' || s === 'CANCELLED') {
    return { label: '已终止', color: 'bg-red-50 text-red-600' };
  }

  return { label: status || '配置中', color: 'bg-gray-100 text-gray-700' };
}
